/**
 * When the selection is inside a `table_cell` / `table_header`, sets a `body` data attribute so
 * theme CSS can hide formatting-toolbar controls that are invalid or misleading in cells
 * (headings, block lists), without patching `@milkdown/crepe`.
 */
import { Plugin, PluginKey } from '@milkdown/kit/prose/state';
import { $prose } from '@milkdown/kit/utils';

import { isInTableCellPos } from './tableCellHardBreak';

export const FORMATTING_TOOLBAR_TABLE_CELL_BODY_ATTR = 'data-bf-formatting-toolbar-table-cell';

const formattingToolbarTableCellKey = new PluginKey('brainfish-formatting-toolbar-table-cell');

function syncBodyAttr(inTableCell: boolean) {
  if (inTableCell) {
    document.body.setAttribute(FORMATTING_TOOLBAR_TABLE_CELL_BODY_ATTR, 'true');
  } else {
    document.body.removeAttribute(FORMATTING_TOOLBAR_TABLE_CELL_BODY_ATTR);
  }
}

export const formattingToolbarTableCellPlugin = $prose(() =>
  new Plugin({
    key: formattingToolbarTableCellKey,
    view(editorView) {
      const sync = () => {
        syncBodyAttr(isInTableCellPos(editorView.state.selection.$from));
      };
      sync();

      return {
        update: (view) => {
          syncBodyAttr(isInTableCellPos(view.state.selection.$from));
        },
        destroy: () => {
          document.body.removeAttribute(FORMATTING_TOOLBAR_TABLE_CELL_BODY_ATTR);
        },
      };
    },
  }),
);
